import * as React from "react";
import { forwardRef } from "react";
const SvgRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", height: 512, viewBox: "0 0 512 512", width: 512, xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m121.373 457.373 201.372-201.373-201.372-201.373a32 32 0 0 1 45.254-45.254l224 224a32 32 0 0 1 0 45.254l-224 224a32 32 0 0 1 -45.254-45.254z" }));
const ForwardRef = forwardRef(SvgRight);
export { ForwardRef as ReactComponent };
